import { Indicator, Info, Row, RowLabel, RowSublabel } from './OptionRow.styles';
import type { OptionRowProps } from './OptionRow.types';

export function OptionRow({
  label,
  sublabel,
  selected,
  onClick,
  disabled,
  mode = 'toggle',
}: OptionRowProps) {
  const selectionProps =
    mode === 'radio' ? { role: 'radio', 'aria-checked': selected } : { 'aria-pressed': selected };

  return (
    <Row
      type="button"
      $selected={selected}
      onClick={onClick}
      disabled={disabled}
      {...selectionProps}
    >
      <Indicator $selected={selected} />
      <Info>
        <RowLabel>{label}</RowLabel>
        {sublabel && <RowSublabel>{sublabel}</RowSublabel>}
      </Info>
    </Row>
  );
}
